
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FileUploadModule, FileUploadValidators } from '@iplab/ngx-file-upload';
import { DlgAnexosComponent, fileNameLengthValidator, fileRequiredValidator } from '../dlg-anexos/dlg-anexos.component';
import { Anexo } from '../../models/Anexo';
import { TareaService } from '../../services/tarea.service';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-dlg-anexos-tarea',
    imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    ReactiveFormsModule,
    FileUploadModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule
],
    templateUrl: './dlg-anexos-tarea.component.html',
    styleUrl: './dlg-anexos-tarea.component.scss'
})
export class DlgAnexosTareaComponent {
  readonly dialogRef = inject(MatDialogRef<DlgAnexosComponent>)
  readonly data = inject<number>(MAT_DIALOG_DATA);

  idTarea: number

  filesLimitMessageError = ""
  numberOfFilesLimit = 4
  filesSizeLimit = 41943040
  usedKB = 0

  postingAnexos = false
  snackbarData: ScnackbarData = {}

  private filesControl = new FormControl<File[]>([], [
    fileRequiredValidator(),
    fileNameLengthValidator(),
    FileUploadValidators.filesLimit(this.numberOfFilesLimit),
    FileUploadValidators.sizeLimit(this.filesSizeLimit)
  ]);
  private descriptionControl = new FormControl("", {
    validators: [
      Validators.maxLength(500)
    ]
  })

  public addAnexoForm = new FormGroup({
    files: this.filesControl,
    description: this.descriptionControl,
  });

  constructor(
    private tareaService: TareaService,
    private toast: ToastService,
  ) {
    this.filesLimitMessageError = `M\xe1ximo ${this.numberOfFilesLimit} ${this.numberOfFilesLimit > 1 ? 'archivos' : 'archivo'} permitido${this.numberOfFilesLimit > 1 ? 's' : ''}`
    this.idTarea = structuredClone(this.data)
  }

  ngOnInit(): void {
    this.addAnexoForm.get('files')?.valueChanges.subscribe(files => {
      if (files) {
        this.updateUsedKB(files);
      }
    });
  }

  updateUsedKB(files: File[]) {
    this.usedKB = files.reduce((total, file) => total + file.size / 1024 / 1024, 0); // Convertir bytes a KB
    this.updateKBsUsedDisplay();
  }

  updateKBsUsedDisplay() {
    const KB = this.filesSizeLimit / 1024 / 1024
    return `${this.usedKB.toFixed(2)}/${KB.toFixed(0)} MB`;
  }

  manageUploadAnexo() {
    this.postingAnexos = true
    const files = this.addAnexoForm.value.files
    const desc = this.addAnexoForm.value.description
    let anexo: Anexo
    if (desc) {
      anexo = {
        file: files!,
        desc: desc,
      }
    } else {
      anexo = {
        file: files!
      }
    }

    this.tareaService.postAnexosTarea(anexo, this.idTarea).subscribe({
      next: (response) => {
        this.snackbarData.message = "Anexo agregado"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.toast.show(this.snackbarData)
        this.dialogRef.close(response)
      },
      error: (_) => {
        this.snackbarData.message = "Error al agregar anexo"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.postingAnexos = false
      }
    })
  }

}
